import React from 'react';
import { IconProps } from './types';

export const NotificationIcon = (props: IconProps) => {
  const { size = 16, color = 'currentColor', style = {} } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      style={style}
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
    >
      <path
        fill={color}
        d='M21 18H3c-.4 0-.8-.3-1-.7-.1-.4 0-.9.4-1.1 0 0 2.6-1.9 2.6-8.2 0-1.9.7-3.6 2.1-4.9C8.4 1.7 10.1 1 12 1c1.9 0 3.6.7 4.9 2.1C18.3 4.4 19 6.1 19 8c0 6.3 2.5 8.2 2.6 8.2.4.3.5.7.4 1.1-.1.4-.6.7-1 .7zM5.1 16h13.7C18 14.5 17 12 17 8c0-1.3-.5-2.6-1.5-3.5-.9-1-2.2-1.5-3.5-1.5-1.3 0-2.6.5-3.5 1.5C7.5 5.4 7 6.7 7 8c0 4-1 6.5-1.9 8zM12 23c-.5 0-1-.1-1.5-.4-.5-.3-.8-.6-1.1-1.1l-.5-.9 1.7-1 .5.9c.1.2.2.3.4.4.3.2.7.2 1 0 .2-.1.3-.2.4-.4l.5-.9 1.7 1-.5.9c-.3.5-.6.8-1.1 1.1-.5.3-1 .4-1.5.4z'
      />
    </svg>
  );
};
